import {helpers} from '@vuelidate/validators'

export const iranianPhone = helpers.withMessage(
  'Invalid phone number',
  value => {
    if (!value) return true

    return /^(09\d{9}|9\d{9})$/.test(value)
  }
)